'use client'

import Link from 'next/link'
import { CaretDown } from '@phosphor-icons/react'

export type PublicNavLink = {
  label: string
  href: string
}

export type PublicNavItem = {
  label: string
  href?: string
  items?: PublicNavLink[]
}

export function publicNavItems(homeHref: string): PublicNavItem[] {
  return [
    { label: 'Home', href: homeHref },
    {
      label: 'Businesses',
      items: [
        { label: 'Producers', href: '/producers' },
        { label: 'Farmers Markets', href: '/markets' },
      ],
    },
    // { label: 'Home Cooks', href: '/homecooks' },
    {
      label: 'Resources',
      items: [
        { label: 'Blog', href: '/blog' },
        { label: 'Explore by Region', href: '/regions' },
        { label: 'Explore on Map', href: '/find' },
      ],
    },
    {
      label: 'About Us',
      items: [
        { label: 'About Us', href: '/about' },
        { label: 'Contact Us', href: '/contact' },
      ],
    },
  ]
}

export function isPublicNavActive(pathname: string, href: string) {
  if (!href || href === '/') return pathname === '/'
  return pathname === href || pathname.startsWith(`${href}/`)
}

export function PublicNavDropdown({
  label,
  items,
  pathname,
  openUp = false,
  onNavigate,
}: {
  label: string
  items: PublicNavLink[]
  pathname: string
  openUp?: boolean
  onNavigate?: () => void
}) {
  const active = items.some((item) => isPublicNavActive(pathname, item.href))

  return (
    <div className="group relative">
      <button
        type="button"
        aria-haspopup="true"
        className={`inline-flex items-center gap-1 ${
          active ? 'text-[#85C349]' : 'hover:text-[#85C349]'
        }`}
      >
        {label}
        <CaretDown size={14} className="transition group-hover:rotate-180 group-focus-within:rotate-180" />
      </button>
      <div
        className={`invisible absolute z-40 opacity-0 transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100 ${
          openUp
            ? 'bottom-full left-1/2 -translate-x-1/2 pb-2'
            : 'left-0 top-full pt-2'
        }`}
      >
        <div className="min-w-[220px] rounded-xl border border-gray-100 bg-white py-2 text-left shadow-lg">
          {items.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              onClick={onNavigate}
              className={`block px-4 py-2 text-sm ${
                isPublicNavActive(pathname, item.href)
                  ? 'text-[#85C349]'
                  : 'text-[#202020] hover:text-[#85C349]'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
